module.exports = __webpack_public_path__ + "static/media/BarlowSemiCondensed-LightItalic.e1c9247d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/BarlowSemiCondensed-LightItalic.ttf
// module id = 3015
// module chunks = 71